import { useState } from "react";
import { StoreState } from "@type/models/store";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { TrackDispatchAndActions } from "../dispatch-files/fetch-dispatch";
import DefaultButton from "../../../components/widgets/default-button";
import TrackOverlayTable from "../modals/track-overlay-result-table";
import "../../../assets/scss/components/modal.scss";
import { CloseOutlined } from "@ant-design/icons";

export const TrackResultModal: React.FC<any> = (props) => {
  const {
    show,
    mkey,
    handlerBack,
    closeModal,
    formData,
    idsexist,
    addExistingTrack,
    loading,
    setData,
  } = props;
  const { tracklist } = useSelector((state: StoreState) => state.suggestion);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const pageSize: number = tracklist?.pagination?.size || 0;
  const totalPages: number = tracklist?.pagination?.pages || 1;
  const defaultDataList = {
    pagination: tracklist.pagination,
    isLoaded: loading,
    list: tracklist.list,
  };
  const dispatch = useDispatch();

  const getPayload = () => {
    const payload: any = {};
    for (const key in formData) {
      if (formData[key]?.value) {
        payload[key] = [formData[key]?.value];
      } else {
        payload[key] = formData[key];
      }
    }
    return payload;
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
      formData.page = currentPage + 1;
      formData.pageSize = pageSize;
      let payload = getPayload();
      const controller = new AbortController();
      const signal = controller.signal;
      TrackDispatchAndActions(dispatch, payload, signal);
    }
  };

  const handlePreviousClick = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
      formData.page = currentPage - 1;
      formData.pageSize = pageSize;
      let payload = getPayload();
      const controller = new AbortController();
      const signal = controller.signal;
      TrackDispatchAndActions(dispatch, payload, signal);
    }
  };

  const handleSelect = () => {
    if (selectedItems.length > 0) {
      addExistingTrack(idsexist);
      closeModal();
      dispatch({
        type: "SET_SELECT_TRACKS",
        payload: [],
      });
      dispatch({ type: "SET_TRACK_LIST", payload: [] });
    }
  };

  const handleDiscard = () => {
    closeModal();
    setData({});
  };

  return (
    <>
      <Modal
        show={show}
        key={"modal_" + mkey}
        size="xl" //'sm' | 'lg' | 'xl'
        backdrop="static"
        onHide={closeModal}
        centered
        className="custom-modal track-overlay-modal"
      >
        <Modal.Header className="track-header-wrapper relative">
          <Modal.Title className="title-wrapper">Result</Modal.Title>
          <div className="absolute top-1/2 right-0 transform -translate-y-1/2  cursor-pointer z-2 title-wrapper">
            <CloseOutlined onClick={handleDiscard} />
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="result-wrapper tw-py-[20px] ">
            <div className="flex tw-flex-wrap tw-gap-[20px] tw-justify-center tw-items-center">
              <DefaultButton
                textColor="var(--color-primary)"
                color="white"
                borderColor="var(--color-primary)"
                onClick={handlerBack}
                className="tw-flex-auto"
              >
                Back
              </DefaultButton>
              <DefaultButton
                textColor="var(--color-primary)"
                color="white"
                borderColor="var(--color-primary)"
                onClick={handlePreviousClick}
                className="tw-flex-auto"
                disabled={currentPage <= 1}
              >
                Previous
              </DefaultButton>
              <DefaultButton
                textColor="var(--color-primary)"
                color="white"
                borderColor="var(--color-primary)"
                onClick={handleNextClick}
                className="tw-flex-auto"
                disabled={currentPage >= totalPages}
              >
                Next
              </DefaultButton>
            </div>
            <div className="tw-mt-[20px]">
              <TrackOverlayTable
                data={{
                  trackSearch: defaultDataList,
                  moreLoading: false,
                }}
                idsexist={idsexist}
                setSelectedItems={setSelectedItems}
                selectedItems={selectedItems}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <DefaultButton
            color="var(--color-primary)"
            textColor="white"
            disabled={selectedItems.length <= 0}
            onClick={handleSelect}
          >
            Select Track
          </DefaultButton>
        </Modal.Footer>
      </Modal>
    </>
  );
};
